import { LanguageCode } from "../types/translations/LanguageCode";
import { TranslationItemNoEn } from "../types/translations/TranslationItem";

export const translationsExactType = {
    // region Common
    by: {
        [LanguageCode.ru]: "от",
        [LanguageCode.de]: "von",
    },
    you: {
        [LanguageCode.ru]: "Вы",
        [LanguageCode.de]: "Du",
    },
    and: {
        [LanguageCode.ru]: "и",
        [LanguageCode.de]: "und",
    },
    or: {
        [LanguageCode.ru]: "или",
        [LanguageCode.de]: "oder",
    },
    Tip: {
        [LanguageCode.ru]: "Подсказка",
        [LanguageCode.de]: "Hinweis",
    },
    ON: {
        [LanguageCode.ru]: "ВКЛ",
        [LanguageCode.de]: "AN",
    },
    OFF: {
        [LanguageCode.ru]: "ВЫКЛ",
        [LanguageCode.de]: "AUS",
    },
    Play: {
        [LanguageCode.ru]: "Играть",
        [LanguageCode.de]: "Spielen",
    },
    "Play %1": {
        [LanguageCode.ru]: "Играть %1",
        [LanguageCode.de]: "%1 spielen",
    },
    Loading: {
        [LanguageCode.ru]: "Подключение",
        [LanguageCode.de]: "Wird geladen",
    },
    Back: {
        [LanguageCode.ru]: "Назад",
        [LanguageCode.de]: "Zurück",
    },
    Yes: {
        [LanguageCode.ru]: "Да",
        [LanguageCode.de]: "Ja",
    },
    No: {
        [LanguageCode.ru]: "Нет",
        [LanguageCode.de]: "Nein",
    },
    Cancel: {
        [LanguageCode.ru]: "Отмена",
        [LanguageCode.de]: "Stornieren",
    },
    Leave: {
        [LanguageCode.ru]: "Выйти",
        [LanguageCode.de]: "Verlassen",
    },
    Close: {
        [LanguageCode.ru]: "Закрыть",
        [LanguageCode.de]: "Schließen",
    },
    "Turn on": {
        [LanguageCode.ru]: "Включить",
        [LanguageCode.de]: "Anmachen",
    },
    "Turn off": {
        [LanguageCode.ru]: "Выключить",
        [LanguageCode.de]: "Abschalten",
    },
    "Stage %1": {
        [LanguageCode.ru]: "Этап %1",
        [LanguageCode.de]: "Stufe %1",
    },
    "zoom in": {
        [LanguageCode.ru]: "приблизить",
        [LanguageCode.de]: "vergrößern",
    },
    "zoom out": {
        [LanguageCode.ru]: "уменьшить",
        [LanguageCode.de]: "verkleinern",
    },
    "Create new game": {
        [LanguageCode.ru]: "Создать новую игру",
        [LanguageCode.de]: "Neues Spiel erstellen",
    },
    "It's %1": {
        [LanguageCode.ru]: "Это %1",
        [LanguageCode.de]: "Das ist %1",
    },
    Skip: {
        [LanguageCode.ru]: "Пропустить",
        [LanguageCode.de]: "Überspringen",
    },
    Next: {
        [LanguageCode.ru]: "Следующий",
        [LanguageCode.de]: "Nächste",
    },
    Questions: {
        [LanguageCode.ru]: "Вопросы",
        [LanguageCode.de]: "Fragen",
    },
    "Your name": {
        [LanguageCode.ru]: "Ваше имя",
        [LanguageCode.de]: "Ihr Name",
    },
    "What's your name?": {
        [LanguageCode.ru]: "Как Вас зовут?",
        [LanguageCode.de]: "Wie heißen Sie?",
    },
    "Hosted by %1": {
        [LanguageCode.ru]: "Ведущий: %1",
        [LanguageCode.de]: "Moderiert von %1",
    },
    "%1's game": {
        [LanguageCode.ru]: "Игра %1",
        [LanguageCode.de]: "Das Spiel von %1",
    },
    "Start the game": {
        [LanguageCode.ru]: "Начать игру",
        [LanguageCode.de]: "Starte das Spiel",
    },
    Submit: {
        [LanguageCode.ru]: "Отправить",
        [LanguageCode.de]: "Einreichen",
    },
    // endregion
    // region App
    "Welcome to Puzzle TV!": {
        [LanguageCode.ru]: "Добро пожаловать на Puzzle TV!",
        [LanguageCode.de]: "Willkommen bei Puzzle TV!",
    },
    "Oops, the puzzle not found!": {
        [LanguageCode.ru]: "Ой, судоку не найден!",
        [LanguageCode.de]: "Hoppla, das Rätsel wurde nicht gefunden!",
    },
    "Go to the home page": {
        [LanguageCode.ru]: "Перейти на домашнюю страницу",
        [LanguageCode.de]: "Gehen Sie zur Startseite",
    },
    // endregion
    // region GamesList
    "Game idea": {
        [LanguageCode.ru]: "Идея игры",
        [LanguageCode.de]: "Spielidee",
    },
    "external link": {
        [LanguageCode.ru]: "внешняя ссылка",
        [LanguageCode.de]: "externer Link",
    },
    // endregion
    // region PageLayout
    "See all puzzles": {
        [LanguageCode.ru]: "Перейти к списку судоку",
        [LanguageCode.de]: "Alle Rätsel ansehen",
    },
    Puzzles: {
        [LanguageCode.ru]: "Судоку",
        [LanguageCode.de]: "Rätsel",
    },
    Games: {
        [LanguageCode.ru]: "Игры",
        [LanguageCode.de]: "Spiele",
    },
    "How to import puzzle": {
        [LanguageCode.ru]: "Как импортировать головоломку",
        [LanguageCode.de]: "So importieren Sie ein Rätsel",
    },
    Contacts: {
        [LanguageCode.ru]: "Контакты",
        [LanguageCode.de]: "Kontakte",
    },
    // endregion
    // region Common for controls
    Shortcut: {
        [LanguageCode.ru]: "Ярлык",
        [LanguageCode.de]: "Hotkey",
    },
    shortcut: {
        [LanguageCode.ru]: "ярлык",
        [LanguageCode.de]: "Hotkey",
    },
    "click to toggle": {
        [LanguageCode.ru]: "нажмите, чтобы переключить",
        [LanguageCode.de]: "klicken Sie zum Umschalten",
    },
    // endregion
    // region Puzzle
    "You opened this puzzle in more than one tab": {
        [LanguageCode.ru]: "Вы открыли эту игру на более чем одной вкладке",
        [LanguageCode.de]: "Sie haben dieses Puzzle in mehr als einem Tab geöffnet",
    },
    "Please leave only one active tab": {
        [LanguageCode.ru]: "Пожалуйста, оставьте только одну активную вкладку",
        [LanguageCode.de]: "Bitte lassen Sie nur einen aktiven Tab",
    },
    "The host of the game is not connected": {
        [LanguageCode.ru]: "Ведущий не подключен",
        [LanguageCode.de]: "Der Host des Spiels ist nicht verbunden",
    },
    "Please wait for them to join": {
        [LanguageCode.ru]: "Пожалуйста, подождите когда он присоединится",
        [LanguageCode.de]: "Warten Sie bitte, bis sie beitreten",
    },
    Join: {
        [LanguageCode.ru]: "Присоединиться",
        [LanguageCode.de]: "Beitreten",
    },
    "Your move": {
        [LanguageCode.ru]: "Ваш ход",
        [LanguageCode.de]: "Ihr Umzug",
    },
    // endregion
    // region Controls
    Corner: {
        [LanguageCode.ru]: "Угол",
        [LanguageCode.de]: "Eckmarkierungen",
    },
    Center: {
        [LanguageCode.ru]: "Центр",
        [LanguageCode.de]: "Mittelmarkierungen",
    },
    Colors: {
        [LanguageCode.ru]: "Цвета",
        [LanguageCode.de]: "Farben",
    },
    Shading: {
        [LanguageCode.ru]: "Штриховка",
        [LanguageCode.de]: "Schattierung",
    },
    Lines: {
        [LanguageCode.ru]: "Линии",
        [LanguageCode.de]: "Linien",
    },
    "Move the grid": {
        [LanguageCode.ru]: "Двигать поле",
        [LanguageCode.de]: "Verschieben Sie das Raster",
    },
    "Reset position": {
        [LanguageCode.ru]: "Сброс позиции",
        [LanguageCode.de]: "Position zurücksetzen",
    },
    "Clear the cell contents": {
        [LanguageCode.ru]: "Очистить содержимое ячейки",
        [LanguageCode.de]: "Löschen Sie den Zellinhalt",
    },
    "Undo the last action": {
        [LanguageCode.ru]: "Отменить последнее действие",
        [LanguageCode.de]: "Machen Sie die letzte Aktion rückgängig",
    },
    "Redo the last action": {
        [LanguageCode.ru]: "Повторить последнее действие",
        [LanguageCode.de]: "Wiederholen Sie die letzte Aktion",
    },
    Undo: {
        [LanguageCode.ru]: "Отмена",
        [LanguageCode.de]: "Rückg.",
    },
    Redo: {
        [LanguageCode.ru]: "Повтор",
        [LanguageCode.de]: "Wdh.",
    },
    "Check the result": {
        [LanguageCode.ru]: "Проверить результат",
        [LanguageCode.de]: "Überprüfen Sie das Ergebnis",
    },
    Congratulations: {
        [LanguageCode.ru]: "Поздравляем",
        [LanguageCode.de]: "Glückwunsch",
    },
    "You lost": {
        [LanguageCode.ru]: "Вы проиграли",
        [LanguageCode.de]: "Du verlierst",
    },
    "Your score is %1": {
        [LanguageCode.ru]: "Вы набрали %1 очков",
        [LanguageCode.de]: "Ihr Punktestand beträgt %1",
    },
    "%1 win": {
        [LanguageCode.ru]: "%1 выиграл(а)",
        [LanguageCode.de]: "%1 gewinnt",
    },
    "You win": {
        [LanguageCode.ru]: "Вы выиграли",
        [LanguageCode.de]: "Du gewinnst",
    },
    "You lose": {
        [LanguageCode.ru]: "Вы проиграли",
        [LanguageCode.de]: "Du verlierst",
    },
    "It's a draw": {
        [LanguageCode.ru]: "Ничья",
        [LanguageCode.de]: "Es ist eine Zeichnung",
    },
    "Solution code": {
        [LanguageCode.ru]: "Код решения",
        [LanguageCode.de]: "Lösungscode",
    },
    "Exit full screen mode": {
        [LanguageCode.ru]: "Выйти из полноэкранного режима",
        [LanguageCode.de]: "Vollbildmodus verlassen",
    },
    "Enter full screen mode": {
        [LanguageCode.ru]: "Войти в полноэкранный режим",
        [LanguageCode.de]: "Zum Vollbildmodus wechseln",
    },
    "Clear the progress and restart": {
        [LanguageCode.ru]: "Очистить прогресс и начать заново",
        [LanguageCode.de]: "Fortschritt löschen und neu starten",
    },
    "Are you sure that you want to restart": {
        [LanguageCode.ru]: "Вы уверены, что хотите начать заново",
        [LanguageCode.de]: "Sind Sie sicher, dass Sie neu starten möchten",
    },
    "All progress will be lost": {
        [LanguageCode.ru]: "Весь прогресс будет потерян",
        [LanguageCode.de]: "Sämtliche Fortschritte gehen verloren",
    },
    "You can't restart the game because you're not hosting it": {
        [LanguageCode.ru]: "Вы не можете начать игру заново, потому что вы не являетесь организатором игры",
        [LanguageCode.de]: "Sie können das Spiel nicht neu starten, da Sie es nicht hosten",
    },
    "If you want to restart the game, please ask the game host to do it": {
        [LanguageCode.ru]: "Если вы хотите перезапустить игру, попросите об этом организатора",
        [LanguageCode.de]: "Wenn Sie das Spiel neu starten möchten, bitten Sie bitte den Spielhost, dies zu tun",
    },
    "Open settings": {
        [LanguageCode.ru]: "Открыть настройки",
        [LanguageCode.de]: "Einstellungen öffnen",
    },
    "Multi-selection": {
        [LanguageCode.ru]: "Выделить несколько клеток",
        [LanguageCode.de]: "Mehrfachauswahl",
    },
    // endregion
    // region RulesSpoiler
    Spoiler: {
        [LanguageCode.ru]: "Спойлер",
        [LanguageCode.de]: "Spoiler",
    },
    "Click to show": {
        [LanguageCode.ru]: "Нажмите, чтоб показать",
        [LanguageCode.de]: "Klicken Sie zum Anzeigen",
    },
    // endregion
    // region Rules
    "Waiting for people to connect": {
        [LanguageCode.ru]: "Ждём, когда люди подключатся",
        [LanguageCode.de]: "Ich warte darauf, dass sich Leute verbinden",
    },
    Score: {
        [LanguageCode.ru]: "Счёт",
        [LanguageCode.de]: "Punktzahl",
    },
    "open in LMD": {
        [LanguageCode.ru]: "открыть в LMD",
        [LanguageCode.de]: "im LMD öffnen",
    },
    // endregion
    // region ChessMainControls
    "Chess piece color": {
        [LanguageCode.ru]: "Цвет фигур",
        [LanguageCode.de]: "Farbe der Schachfigur",
    },
    // endregion
    // region RotatableMainControls
    "Rotate the puzzle": {
        [LanguageCode.ru]: "Повернуть поле",
        [LanguageCode.de]: "Drehe das Rätsel",
    },
    "Sticky mode": {
        [LanguageCode.ru]: "Фиксированный режим",
        [LanguageCode.de]: "Klebriger Modus",
    },
    "Sticky digits are highlighted in green": {
        [LanguageCode.ru]: "Фиксированные цифры помечены зелёным",
        [LanguageCode.de]: "Klebende Ziffern werden grün hervorgehoben",
    },
    // endregion
    // region SettingsContent
    Settings: {
        [LanguageCode.ru]: "Настройки",
        [LanguageCode.de]: "Einstellungen",
    },
    "Highlight conflicts": {
        [LanguageCode.ru]: "Подсвечивать конфликты",
        [LanguageCode.de]: "Heben Sie Konflikte hervor",
    },
    "Check pencilmarks": {
        [LanguageCode.ru]: "Проверять пометки",
        [LanguageCode.de]: "Überprüfen Sie die Bleistiftmarkierungen",
    },
    "Auto-check on finish": {
        [LanguageCode.ru]: "Авто-проверка при завершении",
        [LanguageCode.de]: "Automatische Überprüfung nach Abschluss",
    },
    "Flip keypad": {
        [LanguageCode.ru]: "Перевернуть клавиатуру",
        [LanguageCode.de]: "Drehen Sie das Tastenfeld um",
    },
    "Background color's opacity": {
        [LanguageCode.ru]: "Прорачность цвета фона",
        [LanguageCode.de]: "Deckkraft der Hintergrundfarbe",
    },
    Nickname: {
        [LanguageCode.ru]: "Никнейм",
        [LanguageCode.de]: "Spitzname",
    },
    "Highlight cells seen by selection": {
        [LanguageCode.ru]: "Подсвечивать клетки, видимые выделенными клетками",
        [LanguageCode.de]: "Markieren Sie die durch Auswahl sichtbaren Zellen",
    },
    "Link to the game": {
        [LanguageCode.ru]: "Ссылка на игру",
        [LanguageCode.de]: "Link zum Spiel",
    },
    "Share the link to the game": {
        [LanguageCode.ru]: "Поделиться ссылкой на эту игру",
        [LanguageCode.de]: "Teilen Sie den Link zum Spiel",
    },
    Copy: {
        [LanguageCode.ru]: "Копировать",
        [LanguageCode.de]: "Kopieren",
    },
    "Single-player mode": {
        [LanguageCode.ru]: "Режим одиночной игры",
        [LanguageCode.de]: "Einzelspielermodus",
    },
    "Multi-player mode": {
        [LanguageCode.ru]: "Многопользовательский режим",
        [LanguageCode.de]: "Mehrspielermodus",
    },
    "Host new game": {
        [LanguageCode.ru]: "Хостить новую игру",
        [LanguageCode.de]: "Hosten Sie ein neues Spiel",
    },
    "Start collective solve": {
        [LanguageCode.ru]: "Решать коллективно",
        [LanguageCode.de]: "Beginnen Sie mit der gemeinsamen Lösung",
    },
    // endregion
    // region useMultiPlayer
    host: {
        [LanguageCode.ru]: "ведущий",
        [LanguageCode.de]: "Host",
    },
    guest: {
        [LanguageCode.ru]: "гость",
        [LanguageCode.de]: "Gast",
    },
    // endregion
};

export const translations: Record<string, TranslationItemNoEn> = translationsExactType;
